import { Navigate, Outlet, useLocation } from 'react-router-dom';

import type { RootState } from '@/store';
import { useAppSelector } from '@/store/hooks';

function selectIsAuthed(state: RootState) {
  return Boolean(state.auth.token ?? state.auth.user?.token);
}

/** Private app shell: requires a session; otherwise send user to login. */
export function PrivateRoutes() {
  const authed = useAppSelector(selectIsAuthed);
  const location = useLocation();

  if (!authed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
